"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_TYPE_TO_DOCUMENT_TYPE = exports.INVOICE_TYPE_KEYS = exports.INVOICE_DOCUMENT_TYPE_TO_CATEGORY = exports.INVOICE_CATEGORY = exports.INVOICE_DOCUMENT_TYPE_LABELS = exports.invoiceDocumentTypeSchema = exports.INVOICE_DOCUMENT_TYPES = void 0;
exports.isInvoiceDocumentType = isInvoiceDocumentType;
exports.isInvoiceCategory = isInvoiceCategory;
exports.isRenderableInvoiceType = isRenderableInvoiceType;
const zod_1 = require("zod");
exports.INVOICE_DOCUMENT_TYPES = [
    'invoice_advance',
    'invoice_provisional',
    'invoice_final_settlement',
    'invoice_adjustment',
];
exports.invoiceDocumentTypeSchema = zod_1.z.enum(exports.INVOICE_DOCUMENT_TYPES);
function isInvoiceDocumentType(value) {
    return exports.INVOICE_DOCUMENT_TYPES.includes(value);
}
exports.INVOICE_DOCUMENT_TYPE_LABELS = {
    invoice_advance: 'Advance Invoice',
    invoice_provisional: 'Provisional Invoice',
    invoice_final_settlement: 'Final Settlement Invoice',
    invoice_adjustment: 'Adjustment Note',
};
exports.INVOICE_CATEGORY = 'invoice';
// The four invoice kinds render from one collapsed template whose `category` is
// the shared invoice category itself (not a per-kind document type). UI/preview
// classification keys off the template's category, so it must recognise this.
function isInvoiceCategory(value) {
    return value === exports.INVOICE_CATEGORY;
}
exports.INVOICE_DOCUMENT_TYPE_TO_CATEGORY = {
    invoice_advance: exports.INVOICE_CATEGORY,
    invoice_provisional: exports.INVOICE_CATEGORY,
    invoice_final_settlement: exports.INVOICE_CATEGORY,
    invoice_adjustment: exports.INVOICE_CATEGORY,
};
exports.INVOICE_TYPE_KEYS = [
    'Advance',
    'Provisional',
    'Final_Settlement',
    'Adjustment',
    'Credit_Note',
    'Debit_Note',
];
// Typed note kinds render from the same collapsed adjustment-note template as a legacy Adjustment; only labels differ.
exports.INVOICE_TYPE_TO_DOCUMENT_TYPE = {
    Advance: 'invoice_advance',
    Provisional: 'invoice_provisional',
    Final_Settlement: 'invoice_final_settlement',
    Adjustment: 'invoice_adjustment',
    Credit_Note: 'invoice_adjustment',
    Debit_Note: 'invoice_adjustment',
};
function isRenderableInvoiceType(value) {
    return exports.INVOICE_TYPE_KEYS.includes(value);
}
//# sourceMappingURL=invoice-document-types.js.map